define('entities/webhook_history',[
  'app',
  'jquery',
  'underscore',
  'backbone',
  'settings'
], function (
    App,
    $,
    _,
    Backbone,
    Settings
) {
  'use strict';

  App.reqres.setHandler('webhook-history-url', function (params) {
    return Settings.url('compuzz2', 'webhookHistory/', params);
  });

  App.reqres.setHandler('webhook-history-:row-count-url', function (params) {
    return Settings.url('compuzz2', 'webhookHistory/rowCount', params);
  });

  App.reqres.setHandler('webhook-history:update', function (id, data) {
    var defer = $.Deferred();
    $.ajax({
      type: 'PUT',
      contentType: 'application/json',
      url: Settings.url('compuzz2', 'webhookHistory/' + id),
      data: JSON.stringify(data),
      success: function (resp) { defer.resolve(resp); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('webhook-history:retry', function (id) {
    var defer = $.Deferred();
    $.ajax({
      type: 'POST',
      url: Settings.url('compuzz2', 'webhookHistory/' + id + '/retry'),
      success: function (resp) { defer.resolve(resp); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });
});
